import styled, { css } from 'styled-components';
import colors from '../../../helpers/colors';
import spacing from '../../../helpers/spacing';
import Icon from '../../Icon';
import { IsActiveProps } from '../types';

export const centredIconAndTextStyles = css`
  display: flex;
  align-items: center;
`;

export const TextWithIcon = styled.span`
  ${centredIconAndTextStyles}
`;

export const IconBackground = styled.div<IsActiveProps>`
  height: ${spacing(3)};
  width: ${spacing(3)};
  border-radius: 50%;
  margin-right: ${spacing(2)};

  transition: background-color 0.3s ease-out;
  background-color: ${({ isActive }) => (isActive ? colors.core03 : colors.core01)};

  /* Centre the icon */
  display: flex;
  justify-content: center;
  align-items: center;

  ${Icon} svg {
    position: absolute;
    left: 0;
    top: 0;
  }
`;
